import { createSlice, current, PayloadAction } from "@reduxjs/toolkit";
import { Transfer } from "../../interfaces/HairTransfer";
import { SelfieItemProps } from "../../interfaces/SelfieItemProps";
import { fetchGetSelfie, fetchUploadSelfie } from "../../services/selfie";

// Type definitions
export const initial = {
  selfie: undefined,
  capture: undefined,
  getTransfersResponse: undefined,
  allSelfies: undefined,
  selectedSelfie: undefined,
  isError: false,
  isUpload: false,
  captureAnalysis: undefined,
};
interface ICurrentCustomer {
  selfie: string | undefined;
  capture: string | undefined;
  getTransfersResponse: Transfer[] | undefined;
  allSelfies: SelfieItemProps[];
  selectedSelfie: string;
  isError: boolean;
  isUpload: boolean;
  captureAnalysis: string | undefined;
}

// Define a type for your state
type State = ICurrentCustomer | typeof initial;

const initialState: State = initial;

export const selfieSlice: any = createSlice({
  name: "selfie",
  initialState: initialState as State,
  reducers: {
    setCapture: (state, action) => {
      state.capture = action.payload;
    },
    setCaptureAnalysis: (state, action) => {
      state.captureAnalysis = action.payload;
    },
    setIsUpload: (state, action) => {
      state.isUpload = action.payload;
    },
    resetError: (state) => {
      state.isError = false;
    },
    deleteSelfie: (state, action) => {
      state.selfie = undefined;
      state.getTransfersResponse = undefined;
      state.allSelfies = undefined;
      state.capture = undefined;
    },
    setTransfers: (state, action) => {
      state.getTransfersResponse = action.payload;
    },
    pushOrUpdateTransfer: (state, action) => {
      if (current(state).getTransfersResponse) {
        const oldTransfer = current(state).getTransfersResponse?.find(
          (transfer) => transfer.hairstyleId === action.payload?.hairstyleId
        );
        if (oldTransfer) {
          state.getTransfersResponse = state.getTransfersResponse?.map(
            (transfer: Transfer) => {
              if (transfer.hairstyleId === action.payload?.hairstyleId) {
                return action.payload;
              } else return transfer;
            }
          );
        } else {
          state.getTransfersResponse?.push(action.payload);
        }
      } else {
        const newTransfers: Transfer[] | undefined = [action.payload];
        state.getTransfersResponse = newTransfers;
      }
    },
    setSelectedSelfie: (state, action) => {
      state.selectedSelfie = action.payload;
      state.allSelfies = state.allSelfies?.map((selfie: any) => {
        return {
          ...selfie,
          selected: selfie.id === action.payload,
        } as SelfieItemProps;
      });
    },
  },
  extraReducers(builder) {
    builder.addCase(
      fetchUploadSelfie.pending,
      (state, action: PayloadAction<any | undefined>) => {
        state.allSelfies = undefined;
        state.getTransfersResponse = undefined;
      }
    ),
      builder.addCase(
        fetchUploadSelfie.fulfilled,
        (state, action: PayloadAction<any | undefined>) => {
          state.selfie = action.payload?.data;
          state.isError = false;
        }
      ),
      builder.addCase(
        fetchUploadSelfie.rejected,
        (state, action: PayloadAction<any | undefined>) => {
          state.selfie = undefined;
          state.isError = true;
        }
      ),
      builder.addCase(
        fetchGetSelfie.fulfilled,
        (state, action: PayloadAction<any | undefined>) => {
          state.allSelfies = action.payload?.data?.map((selfie: any) => {
            return {
              id: selfie._id,
              url: selfie.image_url,
              thumbnailUrl: selfie.thumb_url,
              selected: false,
              isAlreadySaved: true,
            } as SelfieItemProps;
          });
        }
      );
  },
});

export const {
  setCapture,
  setCaptureAnalysis,
  setSelectedSelfie,
  deleteSelfie,
  resetError,
  pushOrUpdateTransfer,
  setIsUpload,
} = selfieSlice.actions;

export default selfieSlice.reducer;
